<template>
  <component
    :is="componentType"
    :type="href ? null : type"
    :href="href"
    :disabled="props.disabled"
    class="mx-auto inline-flex items-center"
  >
    <SpanText
      :color="props.color"
      size="text-sm"
      class="flex group"
      :class="props.hoverColor"
    >
      <HeroiconContainer
        :icon="props.icon"
        :color="props.color"
        :class="[props.hoverColor, $slots.default && 'mr-1']"
        :size="props.size"
      /><slot />
    </SpanText>
  </component>
</template>

<script setup>
import HeroiconContainer from '@/Common/Elements/HeroiconContainer.vue'
import SpanText from '@/Common/Text/SpanText.vue'
import { Link } from '@inertiajs/vue3'
import { computed } from 'vue'

const props = defineProps({
  type: {
    type: String,
    default: 'button',
  },
  href: {
    type: String,
    default: null,
  },
  disabled: Boolean,
  external: Boolean,
  icon: Function,
  size: String,
  color: {
    type: String,
    default: 'text-gray-400',
  },
  hoverColor: {
    type: String,
    default:
      'hover:text-gray-500 group-hover:text-gray-500 dark:hover:text-gray-300 dark:group-hover:text-gray-300',
  },
})

const componentType = computed(() => {
  if (props.external) return 'a'

  return props.href && !props.disabled ? Link : 'button'
})
</script>
